(() => {
  if (window.customElements.get('sc-mobile-menu-controller')) {
    return;
  }

  const PAGE_OPEN_CLASS = 'sc-mobile-menu-is-open';
  const FLOOW_MOBILE_MENU_ID = 'floow-mobile-menu-drawer';
  const hasActiveFloowMobileMenu = () => document.getElementById(FLOOW_MOBILE_MENU_ID) !== null;

  document.addEventListener('click', (event) => {
    if (!hasActiveFloowMobileMenu() || typeof window.openMobileMenu !== 'function') {
      return;
    }

    const trigger = event.target.closest?.('[aria-controls="mobile-menu-drawer"]');

    if (!trigger) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    window.openMobileMenu();
  }, true);

  const normalizeLanguageCode = (code) => (code || '').trim().toLocaleLowerCase().replace(/_/g, '-');

  const capitalizeLanguageName = (name) => {
    const normalizedName = (name || '').trim();

    if (!normalizedName) {
      return '';
    }

    return normalizedName.charAt(0).toLocaleUpperCase() + normalizedName.slice(1);
  };

  const getBackgroundImageUrl = (element) => {
    if (!(element instanceof Element)) {
      return '';
    }

    const backgroundImage = element.style.backgroundImage || window.getComputedStyle(element).backgroundImage;
    const urlMatch = backgroundImage.match(/^url\(["']?(.*?)["']?\)$/);
    return urlMatch?.[1] || '';
  };

  const setLanguageFlag = (container, flagUrl, languageCode) => {
    if (!container) {
      return;
    }

    const normalizedFlagUrl = flagUrl || '';
    const normalizedCode = normalizeLanguageCode(languageCode).split('-')[0].toLocaleUpperCase();

    if (
      container.dataset.scMobileFlagUrl === normalizedFlagUrl
      && container.dataset.scMobileFlagCode === normalizedCode
    ) {
      return;
    }

    container.dataset.scMobileFlagUrl = normalizedFlagUrl;
    container.dataset.scMobileFlagCode = normalizedCode;

    if (normalizedFlagUrl) {
      const image = document.createElement('img');
      image.src = normalizedFlagUrl;
      image.alt = '';
      image.width = 24;
      image.height = 18;
      image.loading = 'lazy';
      image.decoding = 'async';
      container.replaceChildren(image);
      return;
    }

    const abbreviation = document.createElement('span');
    abbreviation.textContent = normalizedCode;
    container.replaceChildren(abbreviation);
  };

  const createLanguageCheck = () => {
    const svgNamespace = 'http://www.w3.org/2000/svg';
    const icon = document.createElementNS(svgNamespace, 'svg');
    const path = document.createElementNS(svgNamespace, 'path');

    icon.dataset.scMobileLanguageCheck = '';
    icon.setAttribute('width', '15');
    icon.setAttribute('height', '12');
    icon.setAttribute('viewBox', '0 0 16 12');
    icon.setAttribute('aria-hidden', 'true');
    icon.setAttribute('focusable', 'false');
    path.setAttribute('d', 'm1 6 4.5 4.5L15 1');
    path.setAttribute('fill', 'none');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '2.2');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');
    icon.append(path);
    return icon;
  };

  const setCurrentLanguageRow = (button, isCurrent) => {
    if (!button) {
      return;
    }

    button.classList.toggle('is-current', isCurrent);
    button.toggleAttribute('aria-current', isCurrent);
    const currentCheck = button.querySelector('[data-sc-mobile-language-check]');

    if (isCurrent && !currentCheck) {
      button.append(createLanguageCheck());
    } else if (!isCurrent) {
      currentCheck?.remove();
    }
  };

  const createLanguageItem = (language) => {
    const item = document.createElement('li');
    const button = document.createElement('button');
    const name = document.createElement('span');

    item.dataset.scMobileLanguageItem = '';
    item.dataset.scMobileEtranslateItem = '';
    button.type = 'button';
    button.className = 'sc-mobile-menu__language-row';
    button.dataset.scMobileLanguageCode = language.code;
    name.dataset.scMobileLanguageName = '';
    button.append(name);
    item.append(button);
    return { item, button };
  };

  const readETranslateLanguages = (root) => {
    if (!(root instanceof Element)) {
      return null;
    }

    const currentCode = normalizeLanguageCode(
      root.querySelector('input[name="language_code"]')?.value
    );
    const currentButton = root.querySelector('#etranslate-language-button');
    const currentButtonName = currentButton?.querySelector('.embed-etranslate-language-name');
    const languages = Array.from(
      root.querySelectorAll('.embed-etranslate-lo-select-dropdown-item[data-code]')
    ).map((item) => {
      const code = normalizeLanguageCode(item.dataset.code);
      const nameElement = item.querySelector('.embed-etranslate-language-name');
      const flagElement = item.querySelector('.select-dropdown-flag-icon, .flag-icon');

      return {
        code,
        name: capitalizeLanguageName(item.dataset.name || nameElement?.textContent),
        flagUrl: getBackgroundImageUrl(flagElement),
        source: item,
      };
    }).filter((language, index, allLanguages) => {
      return language.code && allLanguages.findIndex((candidate) => candidate.code === language.code) === index;
    });
    const currentLanguage = languages.find((language) => language.code === currentCode);

    return {
      currentCode,
      currentName: currentLanguage?.name || capitalizeLanguageName(
        currentButtonName?.dataset.name || currentButtonName?.textContent
      ),
      currentFlagUrl: currentLanguage?.flagUrl || getBackgroundImageUrl(
        currentButton?.querySelector('.select-dropdown-flag-icon, .flag-icon')
      ),
      languages,
    };
  };

  const initializeLanguageIntegration = (drawer, signal) => {
    const trigger = drawer.querySelector('[data-sc-mobile-language-trigger]');
    const languagePage = drawer.querySelector('[data-sc-mobile-language-page]');
    const languageList = drawer.querySelector('[data-sc-mobile-language-list]');

    if (!trigger || !languagePage || !languageList) {
      return;
    }

    const triggerName = trigger.querySelector('[data-sc-mobile-language-name]');
    const triggerFlag = trigger.querySelector('[data-sc-mobile-language-flag]');
    const fallbackCurrentCode = normalizeLanguageCode(trigger.dataset.shopifyLanguageCode);
    const fallbackCurrentName = triggerName?.textContent.trim() || '';
    const fallbackCurrentFlagUrl = triggerFlag?.querySelector('img')?.src || '';
    const fallbackRows = Array.from(
      languageList.querySelectorAll('[data-sc-mobile-language-item]')
    ).map((item) => {
      const button = item.querySelector('[data-sc-mobile-language-code]');
      const name = button?.querySelector('[data-sc-mobile-language-name]');
      const flag = button?.querySelector('[data-sc-mobile-language-flag]');

      return {
        item,
        button,
        code: normalizeLanguageCode(button?.dataset.scMobileLanguageCode),
        name: button?.dataset.shopifyLanguageName || name?.textContent.trim() || '',
        flagUrl: flag?.querySelector('img')?.src || '',
      };
    }).filter((language) => language.code);
    const fallbackByCode = new Map(fallbackRows.map((language) => [language.code, language]));
    let eTranslateItemsByCode = new Map();
    let eTranslateRowsByCode = new Map();
    let eTranslateRoot = null;
    let syncFrame = null;
    let discoveryTimer = null;
    let discoveryAttempts = 0;
    const eTranslateObserver = new MutationObserver(() => requestSync());
    const eTranslateParentObserver = new MutationObserver(() => requestSync());

    const updateLanguageRow = (language, row, currentCode) => {
      const name = row.button.querySelector('[data-sc-mobile-language-name]');
      const flag = row.button.querySelector('[data-sc-mobile-language-flag]');

      row.button.dataset.scMobileLanguageCode = language.code;
      name.textContent = language.name;
      setLanguageFlag(flag, language.flagUrl, language.code);
      setCurrentLanguageRow(row.button, language.code === currentCode);
      row.item.hidden = false;
    };

    const restoreShopifyLanguages = () => {
      eTranslateItemsByCode = new Map();
      languageList.querySelectorAll('[data-sc-mobile-etranslate-item]').forEach((item) => item.remove());
      eTranslateRowsByCode = new Map();

      fallbackRows.forEach((language) => {
        updateLanguageRow(language, language, fallbackCurrentCode);
        languageList.append(language.item);
      });

      if (triggerName) {
        triggerName.textContent = fallbackCurrentName;
      }
      setLanguageFlag(triggerFlag, fallbackCurrentFlagUrl, fallbackCurrentCode);

      const hasMultipleLanguages = Number.parseInt(trigger.dataset.shopifyLanguageCount, 10) > 1;
      trigger.hidden = !hasMultipleLanguages;
      languagePage.hidden = !hasMultipleLanguages;
    };

    const applyETranslateLanguages = (data) => {
      if (!data || data.languages.length === 0) {
        restoreShopifyLanguages();
        return;
      }

      const currentCode = data.currentCode || fallbackCurrentCode;
      const appCodes = new Set(data.languages.map((language) => language.code));
      eTranslateItemsByCode = new Map(data.languages.map((language) => [language.code, language.source]));

      fallbackRows.forEach((language) => {
        language.item.hidden = !appCodes.has(language.code);
      });
      languageList.querySelectorAll('[data-sc-mobile-etranslate-item]').forEach((item) => {
        const button = item.querySelector('[data-sc-mobile-language-code]');

        if (!appCodes.has(normalizeLanguageCode(button?.dataset.scMobileLanguageCode))) {
          eTranslateRowsByCode.delete(normalizeLanguageCode(button?.dataset.scMobileLanguageCode));
          item.remove();
        }
      });

      data.languages.forEach((language) => {
        let row = fallbackByCode.get(language.code) || eTranslateRowsByCode.get(language.code);

        if (!row) {
          row = createLanguageItem(language);
          eTranslateRowsByCode.set(language.code, row);
        }

        updateLanguageRow(language, row, currentCode);
        languageList.append(row.item);
      });

      if (triggerName) {
        triggerName.textContent = data.currentName || fallbackCurrentName;
      }
      setLanguageFlag(triggerFlag, data.currentFlagUrl || fallbackCurrentFlagUrl, currentCode);

      const hasMultipleLanguages = data.languages.length > 1;
      trigger.hidden = !hasMultipleLanguages;
      languagePage.hidden = !hasMultipleLanguages;
    };

    const sync = () => {
      syncFrame = null;
      const nextRoot = document.querySelector('#etranslate-language-embedded-selector-theme2');

      if (nextRoot !== eTranslateRoot) {
        eTranslateObserver.disconnect();
        eTranslateParentObserver.disconnect();
        eTranslateRoot = nextRoot;

        if (eTranslateRoot) {
          eTranslateObserver.observe(eTranslateRoot, {
            attributes: true,
            attributeFilter: ['data-code', 'data-name', 'style', 'value'],
            childList: true,
            subtree: true,
          });
          eTranslateParentObserver.observe(eTranslateRoot.parentElement, {
            childList: true,
          });
        }
      }

      if (eTranslateRoot) {
        discoveryAttempts = 0;
        applyETranslateLanguages(readETranslateLanguages(eTranslateRoot));
      } else {
        restoreShopifyLanguages();
        scheduleDiscovery();
      }
    };

    function requestSync() {
      if (syncFrame !== null) {
        return;
      }

      syncFrame = requestAnimationFrame(sync);
    }

    function scheduleDiscovery() {
      if (discoveryTimer !== null || discoveryAttempts >= 60 || signal.aborted) {
        return;
      }

      discoveryTimer = window.setTimeout(() => {
        discoveryTimer = null;
        discoveryAttempts += 1;
        requestSync();
      }, 500);
    }

    trigger.addEventListener('click', requestSync, { signal });
    window.addEventListener('load', requestSync, { once: true, signal });

    languageList.addEventListener('click', (event) => {
      const button = event.target.closest('[data-sc-mobile-language-code]');
      const languageCode = normalizeLanguageCode(button?.dataset.scMobileLanguageCode);
      const sourceItem = eTranslateItemsByCode.get(languageCode);

      if (!button || !sourceItem?.isConnected) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      sourceItem.click();
    }, { signal });

    signal.addEventListener('abort', () => {
      eTranslateObserver.disconnect();
      eTranslateParentObserver.disconnect();

      if (syncFrame !== null) {
        cancelAnimationFrame(syncFrame);
      }

      if (discoveryTimer !== null) {
        window.clearTimeout(discoveryTimer);
      }
    }, { once: true });

    sync();
  };

  const restoreFloowSearch = (drawer) => {
    const host = drawer?.querySelector('[data-sc-mobile-search-host]');
    const connection = host?.__scMobileFloowSearch;

    if (!host || !connection) {
      return;
    }

    connection.controller.abort();
    connection.results.style.display = 'none';

    if (connection.resultsOrigin?.parentNode) {
      connection.resultsOrigin.after(connection.results);
    } else {
      connection.results.remove();
    }

    if (connection.sourceSection) {
      connection.sourceSection.hidden = connection.sourceSectionWasHidden;
    }

    host.classList.remove('is-floow-ready');
    delete host.__scMobileFloowSearch;
  };

  const mountFloowSearch = (drawer) => {
    const host = drawer?.querySelector('[data-sc-mobile-search-host]');
    const mobileInput = host?.querySelector('[data-sc-mobile-search-input]');

    if (!host || !mobileInput) {
      return false;
    }

    const currentConnection = host.__scMobileFloowSearch;

    if (currentConnection?.source.isConnected) {
      return true;
    }

    if (currentConnection) {
      restoreFloowSearch(drawer);
    }

    const source = Array.from(document.querySelectorAll('[data-floow-search]')).find((candidate) => {
      return !candidate.closest('[data-sc-mobile-menu]') && window.getComputedStyle(candidate).display !== 'none';
    });
    const floowInput = source?.querySelector('[data-floow-search-input]');
    const results = source?.querySelector('[data-floow-search-results]');

    if (!source || !floowInput || !results) {
      return false;
    }

    if (!results.__scMobileSearchOrigin) {
      const resultsOrigin = document.createComment('SC Mobile Menu: Floow Search results origin');
      results.before(resultsOrigin);
      results.__scMobileSearchOrigin = resultsOrigin;
    }

    const proxyController = new AbortController();
    const { signal } = proxyController;
    const sourceSection = source.closest('.shopify-section');
    const sourceSectionWasHidden = sourceSection?.hidden || false;

    mobileInput.value = floowInput.value;
    mobileInput.placeholder = floowInput.placeholder || mobileInput.placeholder;
    mobileInput.addEventListener('input', () => {
      floowInput.value = mobileInput.value;
      floowInput.dispatchEvent(new Event('input', { bubbles: true }));
    }, { signal });
    mobileInput.addEventListener('click', (event) => event.stopPropagation(), { signal });
    results.addEventListener('click', (event) => event.stopPropagation(), { signal });

    if (sourceSection) {
      sourceSection.hidden = true;
    }

    host.append(results);
    host.classList.add('is-floow-ready');
    host.__scMobileFloowSearch = {
      controller: proxyController,
      source,
      sourceSection,
      sourceSectionWasHidden,
      results,
      resultsOrigin: results.__scMobileSearchOrigin,
    };

    return true;
  };

  const initializeSwipers = (drawer) => {
    if (typeof window.Swiper !== 'function' || !drawer.isConnected) {
      return false;
    }

    drawer.__scMobileSwipers?.forEach((swiper) => swiper.destroy(true, true));
    drawer.__scMobileSwipers = Array.from(drawer.querySelectorAll('.sc-mobile-menu__swiper')).map((element) => {
      return new window.Swiper(element, {
        slidesPerView: 'auto',
        spaceBetween: 10,
        freeMode: true,
        watchOverflow: true,
        resistanceRatio: 0.65,
      });
    });
    return true;
  };

  const initializeDrawerNavigation = (drawer) => {
    drawer.__scMobileController?.abort();

    const controller = new AbortController();
    const { signal } = controller;
    const rootPage = drawer.querySelector('[data-sc-mobile-root]');
    const pages = Array.from(drawer.querySelectorAll('[data-sc-mobile-page]'));
    let activePage = rootPage;
    let pageStack = rootPage ? [rootPage] : [];
    let resetTimer = null;

    initializeLanguageIntegration(drawer, signal);

    const updateExpandedButtons = (activeIds) => {
      drawer.querySelectorAll('[data-sc-mobile-open][aria-expanded]').forEach((button) => {
        button.setAttribute('aria-expanded', activeIds.has(button.getAttribute('aria-controls')) ? 'true' : 'false');
      });
    };

    const activatePath = (targetPage, focusTarget = true) => {
      if (!targetPage || targetPage === activePage) {
        return;
      }

      const path = [];
      let page = targetPage;

      while (page) {
        path.unshift(page);
        const parentId = page.dataset.scMobileParent;
        page = parentId ? drawer.querySelector(`#${CSS.escape(parentId)}`) : null;
      }

      if (rootPage && path[0] !== rootPage) {
        path.unshift(rootPage);
      }

      pages.forEach((candidate) => {
        const index = path.indexOf(candidate);
        const isActive = candidate === targetPage;
        const isParent = index >= 0 && !isActive;
        candidate.classList.toggle('is-active', isActive);
        candidate.classList.toggle('is-parent', isParent);
        candidate.setAttribute('aria-hidden', String(!isActive));
        candidate.inert = !isActive;
      });

      activePage = targetPage;
      pageStack = path;
      activePage.scrollTop = 0;
      updateExpandedButtons(new Set(path.map((candidate) => candidate.id)));

      drawer.__scMobileSwipers?.forEach((swiper) => swiper.update());

      if (focusTarget) {
        window.setTimeout(() => {
          activePage.querySelector('.sc-mobile-menu__back, input, button, a')?.focus({ preventScroll: true });
        }, 260);
      }
    };

    const resetNavigation = (focusTarget = false) => {
      if (!rootPage) {
        return;
      }

      pages.forEach((page) => {
        const isRoot = page === rootPage;
        page.classList.toggle('is-active', isRoot);
        page.classList.remove('is-parent');
        page.setAttribute('aria-hidden', String(!isRoot));
        page.inert = !isRoot;
        page.scrollTop = 0;
      });
      activePage = rootPage;
      pageStack = [rootPage];
      updateExpandedButtons(new Set());

      if (focusTarget) {
        window.setTimeout(() => {
          rootPage.querySelector('input, button, a')?.focus({ preventScroll: true });
        }, 260);
      }
    };

    drawer.addEventListener('click', (event) => {
      const openButton = event.target.closest('[data-sc-mobile-open]');
      const backButton = event.target.closest('[data-sc-mobile-back]');

      if (openButton && drawer.contains(openButton)) {
        const targetPage = drawer.querySelector(`#${CSS.escape(openButton.dataset.scMobileOpen)}`);

        if (targetPage) {
          event.preventDefault();
          activatePath(targetPage);
        }
        return;
      }

      if (backButton && drawer.contains(backButton)) {
        const targetPage = drawer.querySelector(`#${CSS.escape(backButton.dataset.scMobileBack)}`);

        if (targetPage) {
          event.preventDefault();
          activatePath(targetPage);
        }
      }
    }, { signal });

    drawer.addEventListener('openable-element:open', () => {
      if (resetTimer !== null) {
        window.clearTimeout(resetTimer);
        resetTimer = null;
      }

      document.body?.classList.add(PAGE_OPEN_CLASS);
      resetNavigation(false);
      drawer.__scMobileSwipers?.forEach((swiper) => swiper.update());
    }, { signal });

    drawer.addEventListener('openable-element:close', () => {
      document.body?.classList.remove(PAGE_OPEN_CLASS);

      if (resetTimer !== null) {
        window.clearTimeout(resetTimer);
      }

      resetTimer = window.setTimeout(() => {
        resetTimer = null;
        resetNavigation(false);
      }, 260);
    }, { signal });

    mountFloowSearch(drawer);

    if (window.Shopify?.designMode) {
      document.addEventListener('shopify:block:select', (event) => {
        const blockId = event.detail?.blockId;

        if (!blockId) {
          return;
        }

        const row = drawer.querySelector(
          `[data-sc-mobile-editor-block-id="${CSS.escape(blockId)}"]`
        );

        if (row) {
          drawer.open = true;
          window.setTimeout(() => activatePath(row.closest('[data-sc-mobile-page]'), false), 50);
        }
      }, { signal });
    }

    drawer.__scMobileController = controller;
    document.body?.classList.toggle(PAGE_OPEN_CLASS, drawer.hasAttribute('open'));
    resetNavigation(false);

    signal.addEventListener('abort', () => {
      document.body?.classList.remove(PAGE_OPEN_CLASS);

      if (resetTimer !== null) {
        window.clearTimeout(resetTimer);
      }
    }, { once: true });
  };

  const cleanupMobileMenu = (drawer) => {
    if (!drawer) {
      return;
    }

    restoreFloowSearch(drawer);
    drawer.__scMobileController?.abort();

    drawer.__scMobileSwipers?.forEach((swiper) => swiper.destroy(true, true));
    delete drawer.__scMobileController;
    delete drawer.__scMobileSwipers;
  };

  class SCMobileMenuController extends HTMLElement {
    connectedCallback() {
      if (this.lifecycleController) {
        return;
      }

      this.drawer = this.closest('[data-sc-mobile-menu]');

      if (!this.drawer) {
        return;
      }

      if (hasActiveFloowMobileMenu()) {
        this.drawer.hidden = true;
        this.drawer.inert = true;
        this.drawer.setAttribute('aria-hidden', 'true');
        return;
      }

      this.sectionId = this.drawer.dataset.sectionId;
      this.lifecycleController = new AbortController();
      this.mobileMedia = window.matchMedia('(max-width: 767px)');
      const { signal } = this.lifecycleController;

      this.mobileMedia.addEventListener('change', () => this.handleBreakpoint(), { signal });

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.matches?.('.floow-suchleiste') || event.target.querySelector?.('[data-floow-search]')) {
          this.syncFloowSearch();
        }
      }, { signal });

      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target === this.headerSection) {
          this.drawer.remove();
          return;
        }

        const connection = this.drawer.querySelector('[data-sc-mobile-search-host]')?.__scMobileFloowSearch;
        const origin = connection?.resultsOrigin;

        if (origin && event.target.contains(origin)) {
          restoreFloowSearch(this.drawer);
        }
      }, { signal });

      if (document.readyState !== 'complete') {
        window.addEventListener('load', () => {
          if (this.mobileMedia.matches) {
            initializeSwipers(this.drawer);
          }
        }, {
          once: true,
          signal,
        });
      }

      this.handleBreakpoint();
    }

    disconnectedCallback() {
      this.lifecycleController?.abort();
      cleanupMobileMenu(this.drawer);
      this.lifecycleController = null;
      this.drawer = null;
      this.headerSection = null;
      this.mobileMedia = null;
    }

    initializeMenu() {
      if (!this.mobileMedia?.matches || !this.drawer?.isConnected || !this.sectionId) {
        return;
      }

      this.headerSection = document.getElementById(`shopify-section-${this.sectionId}`);

      if (!this.headerSection) {
        return;
      }

      document.querySelectorAll(
        `[data-sc-mobile-menu][data-section-id="${CSS.escape(this.sectionId)}"]`
      ).forEach((candidate) => {
        if (candidate !== this.drawer) {
          restoreFloowSearch(candidate);
          candidate.remove();
        }
      });

      initializeDrawerNavigation(this.drawer);
      initializeSwipers(this.drawer);
    }

    handleBreakpoint() {
      if (this.mobileMedia.matches) {
        this.initializeMenu();
        return;
      }

      if (this.drawer.hasAttribute('open')) {
        this.drawer.open = false;
      }

      cleanupMobileMenu(this.drawer);
    }

    syncFloowSearch() {
      if (this.mobileMedia.matches) {
        mountFloowSearch(this.drawer);
      } else {
        restoreFloowSearch(this.drawer);
      }
    }
  }

  window.customElements.define('sc-mobile-menu-controller', SCMobileMenuController);
})();
